<template>
  <v-card class="mt-6 mb-13">
    <slot></slot>
  </v-card>
</template>

<script>
export default {};
</script>

<style>
</style>
